<template>
  <!-- Isi Pemberitahuan Privasi (Privacy Notice); dipakai dialog login dan halaman /privacy-notice -->
  <div class="privacy">
    <h3>Ringkasan Pemberitahuan</h3>
    <p>Diperbarui pada 22 September 2026</p>
    <p>
      PTPN IV memproses Data Pribadi untuk tujuan yang sah dan spesifik, berdasarkan dasar pemrosesan yang sesuai,
      dengan menerapkan prinsip minimisasi, keamanan, transparansi, dan akuntabilitas. Pemberitahuan Privasi ini
      bersifat umum dan dapat dilengkapi dengan Pemberitahuan Privasi yang lebih spesifik untuk kegiatan seperti
      kepegawaian, rekrutmen, pengadaan/vendor, kunjungan/CCTV, situs web/layanan digital, kegiatan/acara, atau
      pemrosesan tertentu lainnya.
    </p>

    <h3>1. Istilah dan Definisi</h3>
    <p>
      Untuk memudahkan pemahaman Pemberitahuan Privasi ini, istilah berikut digunakan dengan pengertian
      sebagaimana
      dijelaskan di bawah ini. Apabila suatu istilah memiliki pengertian khusus berdasarkan peraturan
      perundang-undangan yang berlaku, pengertian dalam peraturan tersebut yang digunakan.
    </p>
    <div class="privacy__table-wrap">
      <table>
        <thead>
          <tr>
            <th>Istilah</th>
            <th>Definisi</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Data Pribadi</th>
            <td>Data tentang orang perseorangan yang teridentifikasi atau dapat diidentifikasi, baik secara
              tersendiri maupun dikombinasikan dengan informasi lain, secara langsung maupun tidak langsung.</td>
          </tr>
          <tr>
            <th scope="row">Data Pribadi yang Bersifat Spesifik</th>
            <td>Data Pribadi yang karena sifat dan risikonya memerlukan tingkat pelindungan lebih tinggi, termasuk
              antara lain data kesehatan, data biometrik, data genetika, catatan kejahatan, data anak, dan data
              keuangan pribadi sesuai ketentuan yang berlaku.</td>
          </tr>
          <tr>
            <th scope="row">Subjek Data Pribadi</th>
            <td>Orang perseorangan yang pada dirinya melekat Data Pribadi.</td>
          </tr>
          <tr>
            <th scope="row">Pemrosesan Data Pribadi</th>
            <td>Setiap tindakan terhadap Data Pribadi, termasuk pemerolehan dan pengumpulan, pengolahan dan
              penganalisisan, penyimpanan, perbaikan dan pembaruan, penampilan atau pengungkapan, transfer, serta
              penghapusan atau pemusnahan.</td>
          </tr>
          <tr>
            <th scope="row">Pengendali Data Pribadi</th>
            <td>Pihak yang menentukan tujuan dan melakukan kendali atas pemrosesan Data Pribadi.</td>
          </tr>
          <tr>
            <th scope="row">Pengendali Data Pribadi Bersama</th>
            <td>Dua atau lebih Pengendali Data Pribadi yang secara bersama-sama menentukan tujuan dan/atau aspek
              utama pemrosesan serta mengatur pembagian peran dan tanggung jawab sesuai ketentuan yang berlaku.
            </td>
          </tr>
          <tr>
            <th scope="row">Prosesor Data Pribadi</th>
            <td>Pihak yang melakukan pemrosesan Data Pribadi atas nama Pengendali Data Pribadi berdasarkan
              instruksi
              dan pengaturan yang terdokumentasi.</td>
          </tr>
          <tr>
            <th scope="row">Pemberitahuan Privasi (<i>Privacy Notice</i>)</th>
            <td>Informasi yang diberikan kepada Subjek Data Pribadi mengenai bagaimana Data Pribadinya diperoleh,
              digunakan, disimpan, diungkapkan, ditransfer, dilindungi, dan dikelola, termasuk hak Subjek Data dan
              kanal pelaksanaan hak.</td>
          </tr>
          <tr>
            <th scope="row">Persetujuan</th>
            <td>Pernyataan kehendak Subjek Data Pribadi yang diberikan secara sah, eksplisit, spesifik,
              diinformasikan, dapat dibuktikan, dan dapat ditarik kembali apabila persetujuan digunakan sebagai
              dasar pemrosesan.</td>
          </tr>
          <tr>
            <th scope="row">RoPA (<i>Record of Processing Activities</i>)</th>
            <td>Rekaman kegiatan pemrosesan Data Pribadi yang mendokumentasikan antara lain tujuan, kategori Data
              Pribadi, dasar pemrosesan, pihak penerima, lokasi pemrosesan, retensi, transfer, dan langkah
              pengamanan yang relevan.</td>
          </tr>
          <tr>
            <th scope="row">DPIA (<i>Data Protection Impact Assessment</i>)</th>
            <td>Penilaian Dampak Pelindungan Data Pribadi yang dilakukan untuk menilai risiko dan langkah
              pengendalian atas kegiatan pemrosesan yang berpotensi menimbulkan risiko tinggi terhadap Subjek Data
              Pribadi.</td>
          </tr>
          <tr>
            <th scope="row">PPDP (Pejabat Pelindungan Data Pribadi) / DPO (<i>Data Protection Officer</i>)</th>
            <td>Pejabat atau Petugas yang Melaksanakan Fungsi Pelindungan Data Pribadi sesuai ketentuan peraturan
              perundang-undangan dan tata kelola Perusahaan.</td>
          </tr>
          <tr>
            <th scope="row"><i>Profiling</i></th>
            <td>Pemrosesan Data Pribadi, khususnya secara otomatis, untuk mengevaluasi, menganalisis, atau
              memprediksi aspek tertentu mengenai seseorang, misalnya kinerja, perilaku, preferensi, atau
              karakteristik lainnya.</td>
          </tr>
          <tr>
            <th scope="row">Kegagalan Pelindungan Data Pribadi</th>
            <td>Peristiwa yang menyebabkan atau berpotensi menyebabkan Data Pribadi hilang, rusak, berubah,
              terungkap, diakses, atau diproses secara tidak sah sehingga memengaruhi kerahasiaan, integritas,
              dan/atau ketersediaannya.</td>
          </tr>
          <tr>
            <th scope="row">Transfer Data Pribadi ke Luar Wilayah Indonesia</th>
            <td>Pemindahan atau pemberian akses Data Pribadi kepada Pengendali Data Pribadi dan/atau Prosesor Data
              Pribadi yang berada di luar wilayah hukum Republik Indonesia.</td>
          </tr>
          <tr>
            <th scope="row">Masa Retensi</th>
            <td>Jangka waktu Data Pribadi disimpan berdasarkan tujuan pemrosesan, kewajiban hukum, kebutuhan
              pembuktian, Jadwal Retensi Arsip (JRA), dan/atau kriteria lain yang sah.</td>
          </tr>
          <tr>
            <th scope="row"><i>Privacy by Design</i> dan <i>Privacy by Default</i></th>
            <td>Pendekatan yang mengintegrasikan pelindungan Data Pribadi sejak tahap perancangan proses, sistem,
              produk, atau layanan serta menetapkan pengaturan awal yang membatasi pemrosesan pada Data Pribadi
              yang
              diperlukan untuk tujuan yang sah.</td>
          </tr>
          <tr>
            <th scope="row">Lembaga</th>
            <td>Lembaga atau otoritas yang memiliki kewenangan di bidang Pelindungan Data Pribadi sesuai ketentuan
              peraturan perundang-undangan yang berlaku.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3>2. Identitas dan Peran PTPN IV</h3>
    <p>
      PT Perkebunan Nusantara IV ("PTPN IV" atau "Perusahaan") merupakan badan usaha yang dapat bertindak sebagai
      Pengendali Data Pribadi, Pengendali Data Pribadi Bersama, dan/atau Prosesor Data Pribadi sesuai fakta,
      tujuan,
      kewenangan, dan hubungan hukum dalam suatu kegiatan pemrosesan.
    </p>
    <p>
      Dalam kapasitasnya sebagai Pengendali Data Pribadi, PTPN IV menentukan tujuan dan melakukan kendali atas
      pemrosesan Data Pribadi. Dalam hal PTPN IV bertindak sebagai Prosesor Data Pribadi, pemrosesan dilakukan
      berdasarkan instruksi terdokumentasi dari Pengendali Data Pribadi yang relevan dan ketentuan perjanjian yang
      berlaku.
    </p>
    <p>
      Dalam hal PTPN IV bertindak semata-mata sebagai Prosesor Data Pribadi, informasi kepada Subjek Data Pribadi
      diberikan sesuai instruksi, pengaturan, dan tanggung jawab Pengendali Data Pribadi yang relevan, kecuali
      PTPN IV
      diwajibkan lain berdasarkan ketentuan peraturan perundang-undangan.
    </p>
    <p>
      Dalam hal pemrosesan dilakukan bersama dengan Pengendali Data Pribadi lain, Pemberitahuan Privasi yang
      relevan
      akan menginformasikan identitas para Pengendali yang terlibat, hubungan dan/atau pembagian peran serta
      tanggung
      jawab, mekanisme pelaksanaan hak Subjek Data Pribadi, dan narahubung yang dapat dihubungi sesuai ketentuan
      yang
      berlaku.
    </p>
    <p>
      Pemberitahuan Privasi ini bukan merupakan persetujuan umum (<i>blanket consent</i>). Apabila persetujuan
      diperlukan sebagai dasar pemrosesan tertentu, persetujuan akan diminta secara terpisah, eksplisit, spesifik,
      diinformasikan, dapat dibuktikan, dan dapat ditarik kembali sesuai ketentuan yang berlaku.
    </p>

    <h3>3. Ruang Lingkup Pemberitahuan</h3>
    <p>
      Pemberitahuan Privasi ini berlaku terhadap kegiatan pemrosesan Data Pribadi yang dilakukan oleh atau atas
      nama
      PTPN IV, baik secara elektronik maupun nonelektronik, sepanjang PTPN IV berkedudukan sebagai Pengendali Data
      Pribadi dan/atau pihak yang wajib memberikan informasi kepada Subjek Data Pribadi.
    </p>
    <p>
      Pemrosesan dapat dilakukan melalui aplikasi, sistem informasi, situs web, platform digital, database, surat
      elektronik, perangkat, jaringan, layanan komputasi awan, formulir, kontrak, dokumen fisik, arsip, rekaman
      audio/video, CCTV, sistem kontrol akses, maupun sarana pemrosesan lainnya.
    </p>
    <p>
      Apabila tersedia Pemberitahuan Privasi yang lebih spesifik untuk kegiatan pemrosesan tertentu, Pemberitahuan
      Privasi yang lebih spesifik tersebut berlaku sebagai informasi tambahan dan harus dibaca bersama dengan
      Pemberitahuan ini.
    </p>

    <h3>4. Kategori Subjek Data Pribadi</h3>
    <p>Pemberitahuan ini dapat berlaku bagi individu yang Data Pribadinya diproses oleh atau atas nama PTPN IV,
      antara lain:</p>
    <ol type="a">
      <li>pegawai, pekerja, dan tenaga kerja lainnya;</li>
      <li>calon pegawai atau kandidat rekrutmen;</li>
      <li>pengguna layanan dan/atau pelanggan apabila relevan;</li>
      <li>mitra, vendor, kontraktor, konsultan, dan perwakilannya;</li>
      <li>pengunjung, tamu, dan individu yang mengakses fasilitas PTPN IV;</li>
      <li>perwakilan pemegang saham dan pemangku kepentingan;</li>
      <li>masyarakat atau individu yang berinteraksi dengan PTPN IV; dan</li>
      <li>Subjek Data Pribadi lain sesuai kegiatan pemrosesan yang sah.</li>
    </ol>

    <h3>5. Kategori Data Pribadi yang Diproses</h3>
    <p>
      PTPN IV memproses Data Pribadi yang relevan dan diperlukan sesuai tujuan kegiatan pemrosesan. Kategori
      tersebut
      dapat mencakup Data Pribadi yang bersifat umum dan Data Pribadi yang bersifat spesifik sesuai UU PDP, antara
      lain:
    </p>
    <div class="privacy__table-wrap">
      <table>
        <thead>
          <tr>
            <th>Kategori</th>
            <th>Contoh Data</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Identitas dan kontak</th>
            <td>nama, nomor identitas internal/kepegawaian, alamat, nomor telepon, alamat e-mail, foto, jabatan,
              unit kerja, dan informasi identifikasi lain yang relevan.</td>
          </tr>
          <tr>
            <th scope="row">Hubungan kerja dan rekrutmen</th>
            <td>riwayat kerja, pendidikan, kompetensi, presensi, cuti, penugasan, kinerja, administrasi SDM, dan
              informasi kandidat.</td>
          </tr>
          <tr>
            <th scope="row">Keuangan pribadi</th>
            <td>informasi penggajian, remunerasi, tunjangan, pembayaran, rekening atau informasi keuangan lain
              sepanjang diperlukan dan diperkenankan.</td>
          </tr>
          <tr>
            <th scope="row">Teknis, perangkat, dan penggunaan</th>
            <td>alamat IP, <i>timestamp</i>, identitas perangkat, informasi jaringan, log aktivitas, catatan
              autentikasi, penggunaan sistem, dan informasi keamanan.</td>
          </tr>
          <tr>
            <th scope="row">Transaksi, komunikasi, dan dokumen</th>
            <td>korespondensi, kontrak, formulir, dokumen, lampiran, rekaman transaksi, persetujuan, <i>audit
                trail</i>, pengaduan, dan komunikasi terkait.</td>
          </tr>
          <tr>
            <th scope="row">Keamanan fisik</th>
            <td>rekaman CCTV, catatan kunjungan, kartu akses, lokasi akses, waktu akses, dan informasi fasilitas.
            </td>
          </tr>
          <tr>
            <th scope="row">Data Pribadi spesifik</th>
            <td>data kesehatan, biometrik, data anak, data keuangan pribadi, dan kategori Data Pribadi spesifik
              lainnya apabila memang diproses untuk tujuan yang sah.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3>6. Sumber dan Cara Perolehan Data Pribadi</h3>
    <p>
      Data Pribadi dapat diperoleh langsung dari Subjek Data Pribadi melalui formulir, kontrak/perjanjian,
      korespondensi, transaksi, rekrutmen, hubungan kerja, kunjungan, pengaduan, kegiatan, atau interaksi lainnya.
    </p>
    <p>
      Data Pribadi dapat dikumpulkan secara otomatis melalui sarana elektronik dan perangkat pemantauan yang sah,
      termasuk log sistem, alamat IP, <i>timestamp</i>, rekaman akses, CCTV, dan kontrol akses.
    </p>
    <p>
      Data Pribadi dapat diperoleh dari unit internal, perusahaan dalam kelompok usaha, Pengendali/Prosesor lain,
      mitra, vendor, penyedia layanan, instansi pemerintah, sumber terbuka yang sah, atau pihak lain yang
      berwenang.
    </p>
    <p>
      Dalam hal Data Pribadi diperoleh secara tidak langsung, PTPN IV memberikan informasi yang diwajibkan kepada
      Subjek Data Pribadi paling lambat 30 (tiga puluh) hari sejak Data Pribadi diperoleh, kecuali terdapat
      pengecualian yang sah berdasarkan peraturan perundang-undangan.
    </p>

    <h3>7. Tujuan dan Dasar Pemrosesan Data Pribadi</h3>
    <p>
      PTPN IV menetapkan dan mendokumentasikan dasar pemrosesan yang sesuai untuk setiap kegiatan pemrosesan.
      Dasar
      pemrosesan dapat berupa persetujuan, pelaksanaan perjanjian atau langkah pra-kontraktual, kewajiban hukum,
      kepentingan vital, kepentingan umum/kewenangan berdasarkan peraturan perundang-undangan, dan/atau
      kepentingan sah
      yang telah dinilai. Dasar pemrosesan yang benar-benar digunakan ditetapkan untuk setiap kegiatan dan
      didokumentasikan dalam ROPA serta, apabila diperlukan, diinformasikan lebih spesifik dalam Pemberitahuan
      Privasi
      yang relevan. Pencantuman beberapa dasar dalam Pemberitahuan Privasi Umum ini tidak berarti seluruh dasar
      tersebut
      digunakan secara bersamaan untuk setiap kegiatan pemrosesan.
    </p>
    <div class="privacy__table-wrap">
      <table>
        <thead>
          <tr>
            <th>Konteks</th>
            <th>Tujuan Utama</th>
            <th>Dasar Pemrosesan yang Dapat Berlaku</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Kepegawaian dan pengelolaan SDM</th>
            <td>administrasi hubungan kerja, presensi, remunerasi, kompetensi, kinerja, benefit, keselamatan, dan
              pemenuhan kewajiban ketenagakerjaan.</td>
            <td>Pelaksanaan hubungan/perjanjian kerja; kewajiban hukum; kepentingan sah; persetujuan apabila
              secara
              khusus diperlukan.</td>
          </tr>
          <tr>
            <th scope="row">Rekrutmen</th>
            <td>seleksi kandidat, komunikasi, verifikasi kualifikasi, administrasi proses rekrutmen, dan
              pembentukan
              hubungan kerja.</td>
            <td>Langkah pra-kontraktual; kepentingan sah; kewajiban hukum; persetujuan apabila diperlukan.</td>
          </tr>
          <tr>
            <th scope="row">Pengadaan, vendor, mitra, dan kontraktor</th>
            <td>uji kelayakan, administrasi pengadaan, kontrak, pembayaran, evaluasi, keamanan, kepatuhan, dan
              pengelolaan hubungan bisnis.</td>
            <td>Pelaksanaan perjanjian/pra-kontraktual; kewajiban hukum; kepentingan sah.</td>
          </tr>
          <tr>
            <th scope="row">Layanan, transaksi, dan proses bisnis</th>
            <td>penyelenggaraan layanan, transaksi, komunikasi, dokumentasi, persetujuan, autentikasi, dan
              dukungan
              proses bisnis.</td>
            <td>Pelaksanaan perjanjian; kewajiban hukum; kepentingan sah; persetujuan apabila relevan.</td>
          </tr>
          <tr>
            <th scope="row">Keamanan fisik dan akses fasilitas</th>
            <td>kontrol akses, keselamatan, keamanan lokasi, pencegahan insiden, dan investigasi yang sah.</td>
            <td>Kewajiban hukum; kepentingan sah; dasar lain yang diperkenankan sesuai konteks.</td>
          </tr>
          <tr>
            <th scope="row">Keamanan informasi, TI, logging, dan audit</th>
            <td>pengamanan sistem/jaringan, autentikasi, monitoring, <i>audit trail</i>, pencegahan
              penyalahgunaan,
              deteksi dan respons insiden.</td>
            <td>Kewajiban hukum; kepentingan sah; pelaksanaan kepentingan umum/kewenangan jika relevan.</td>
          </tr>
          <tr>
            <th scope="row">Kepatuhan, hukum, audit, dan sengketa</th>
            <td>memenuhi kewajiban regulator, audit, pembuktian, pengaduan, penyelesaian sengketa, investigasi,
              dan
              penegakan hak hukum.</td>
            <td>Kewajiban hukum; kepentingan sah; kepentingan umum/kewenangan jika relevan.</td>
          </tr>
          <tr>
            <th scope="row">Kegiatan, komunikasi, dan interaksi pemangku kepentingan</th>
            <td>koordinasi, pelaksanaan kegiatan, komunikasi, penyampaian informasi, dokumentasi, dan tindak
              lanjut.
            </td>
            <td>Kepentingan sah; pelaksanaan perjanjian; persetujuan apabila kegiatan tertentu mensyaratkannya.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <b>Perubahan tujuan pemrosesan.</b> Apabila PTPN IV akan memproses Data Pribadi untuk tujuan baru yang belum
      tercakup dalam tujuan awal, PTPN IV menilai kesesuaian tujuan, menetapkan dasar pemrosesan yang sah,
      memperbarui
      ROPA dan/atau DPIA apabila diperlukan, serta menyampaikan informasi kepada Subjek Data Pribadi sebelum
      pemrosesan
      untuk tujuan baru dilaksanakan sesuai ketentuan yang berlaku.
    </p>

    <h3>8. Kewajiban Memberikan Data Pribadi dan Konsekuensinya</h3>
    <p>
      Subjek Data Pribadi tidak selalu berkewajiban memberikan seluruh Data Pribadi yang diminta. Namun, apabila
      Data
      Pribadi tertentu diperlukan untuk pelaksanaan layanan, transaksi, hubungan kerja atau kontraktual,
      rekrutmen,
      kewajiban hukum, keamanan, pengadaan, akses fasilitas, atau tujuan sah lainnya, PTPN IV akan
      menginformasikan
      sifat wajib atau sukarela pemberian Data Pribadi serta konsekuensi apabila Data Pribadi yang diperlukan
      tidak
      diberikan. Dalam kondisi tersebut, PTPN IV mungkin tidak dapat memproses permintaan atau melaksanakan
      layanan/proses terkait sebagaimana mestinya.
    </p>

    <h3>9. Pengungkapan kepada Penerima dan Pihak Ketiga</h3>
    <p>
      Sepanjang diperlukan untuk tujuan pemrosesan yang sah dan sesuai prinsip minimisasi, <i>need-to-know</i>,
      kerahasiaan, dan keamanan, Data Pribadi dapat diungkapkan kepada:
    </p>
    <ol type="a">
      <li>unit kerja internal dan/atau perusahaan dalam kelompok usaha yang berwenang;</li>
      <li>Pengendali Data Pribadi lain atau Pengendali Bersama yang relevan;</li>
      <li>Prosesor Data Pribadi, penyedia layanan teknologi, cloud, pusat data, hosting, komunikasi, keamanan, dan
        penyimpanan;</li>
      <li>mitra profesional, konsultan, auditor, penasihat hukum, dan penyedia jasa lainnya;</li>
      <li>pemerintah, regulator, aparat penegak hukum, lembaga peradilan, atau pihak lain berdasarkan kewajiban
        hukum atau perintah yang sah; dan</li>
      <li>penerima lain yang diinformasikan dalam Pemberitahuan Privasi spesifik atau sesuai dasar pemrosesan yang
        sah.</li>
    </ol>
    <p>
      Dalam menggunakan Prosesor Data Pribadi, PTPN IV menetapkan instruksi pemrosesan, persyaratan keamanan dan
      kerahasiaan, bantuan pemenuhan hak Subjek Data, penanganan insiden, ketentuan retensi/penghapusan, serta
      pengaturan subprosesor melalui perjanjian yang terdokumentasi.
    </p>
    <p>
      Apabila Data Pribadi diproses dalam skema Pengendali Data Pribadi Bersama, PTPN IV dan Pengendali lainnya
      mendokumentasikan pengaturan yang relevan dan memberikan informasi yang diperlukan kepada Subjek Data
      Pribadi,
      termasuk pembagian tanggung jawab dan mekanisme pelaksanaan hak.
    </p>

    <h3>10. Transfer Data Pribadi ke Luar Wilayah Indonesia</h3>
    <p>
      Apabila Data Pribadi perlu ditransfer ke Pengendali Data Pribadi dan/atau Prosesor Data Pribadi di luar
      wilayah
      hukum Republik Indonesia, PTPN IV menentukan kebutuhan, tujuan, kategori Data Pribadi, penerima,
      negara/organisasi tujuan, lokasi pemrosesan/penyimpanan, risiko transfer, dan instrumen pelindungan yang
      digunakan.
    </p>
    <p>Transfer lintas negara dilakukan secara berjenjang:</p>
    <ol>
      <li>memastikan negara/organisasi penerima memiliki tingkat Pelindungan Data Pribadi yang setara atau lebih
        tinggi;</li>
      <li>apabila tidak terpenuhi, memastikan terdapat pelindungan yang memadai dan bersifat mengikat melalui
        instrumen yang sah; dan</li>
      <li>apabila kedua mekanisme tersebut tidak dapat dipenuhi, memperoleh persetujuan Subjek Data Pribadi sesuai
        persyaratan yang berlaku.</li>
    </ol>
    <p>
      Apabila transfer lintas negara benar-benar dilakukan, informasi mengenai negara/organisasi tujuan, kategori
      penerima, dan/atau mekanisme pelindungan transfer yang relevan akan diberikan melalui Pemberitahuan Privasi
      spesifik, perjanjian, atau kanal resmi lainnya sesuai konteks pemrosesan dan ketentuan yang berlaku.
    </p>

    <h3>11. Masa Retensi, Penghapusan, dan Pemusnahan</h3>
    <p>
      PTPN IV menyimpan Data Pribadi selama diperlukan untuk mencapai tujuan pemrosesan, memenuhi kewajiban hukum,
      hubungan kontraktual atau hubungan kerja, kebutuhan pembuktian dan audit, serta sesuai Jadwal Retensi Arsip
      (JRA),
      ROPA, dan kebijakan retensi yang berlaku. PTPN IV tidak menyimpan Data Pribadi lebih lama dari yang
      diperlukan
      kecuali diwajibkan atau diperkenankan oleh hukum.
    </p>
    <p>
      Pada saat pengumpulan atau sebelum pemrosesan dimulai, masa retensi atau kriteria penentuan masa retensi dan
      jangka waktu pemrosesan yang relevan diberikan melalui Pemberitahuan Privasi spesifik atau media informasi
      yang
      sesuai. Setelah retensi berakhir atau terdapat dasar lain yang sah, Data Pribadi dihapus, dimusnahkan,
      dianonimkan, dan/atau dikembalikan kepada pihak yang berhak sesuai ketentuan yang berlaku.
    </p>

    <h3>12. Pemrosesan Otomatis dan <i>Profiling</i></h3>
    <p>
      Apabila PTPN IV menerapkan pengambilan keputusan yang semata-mata didasarkan pada pemrosesan otomatis,
      termasuk
      <i>profiling</i>, yang menimbulkan akibat hukum atau berdampak signifikan terhadap Subjek Data Pribadi, PTPN
      IV
      akan menginformasikan keberadaan pemrosesan tersebut, informasi yang relevan mengenai logika yang digunakan
      dan
      konsekuensinya, menyediakan mekanisme keberatan dan peninjauan oleh manusia, serta melaksanakan DPIA apabila
      pemrosesan memenuhi kriteria risiko tinggi.
    </p>

    <h3>13. Data Pribadi Anak dan Penyandang Disabilitas</h3>
    <p>
      Apabila PTPN IV memproses Data Pribadi anak, pemrosesan dilakukan secara khusus dengan pelindungan tambahan,
      persetujuan orang tua dan/atau wali sesuai ketentuan, mekanisme verifikasi yang proporsional, dan
      memperhatikan
      kepentingan terbaik bagi anak.
    </p>
    <p>
      Pemrosesan Data Pribadi penyandang disabilitas dilakukan dengan menjamin kesetaraan, aksesibilitas,
      kerahasiaan,
      dan penghormatan atas hak Subjek Data. Apabila persetujuan menjadi dasar pemrosesan, persetujuan diperoleh
      dari
      penyandang disabilitas dan/atau wali sesuai ketentuan yang berlaku.
    </p>

    <h3>14. Pengamanan Data Pribadi</h3>
    <p>
      PTPN IV menerapkan langkah teknis, organisasi, fisik, dan administratif yang sesuai dengan risiko untuk
      melindungi
      Data Pribadi dari akses, penggunaan, pengungkapan, perubahan, kehilangan, penghancuran, atau pemrosesan yang
      tidak
      sah. Pengamanan dapat mencakup pengelolaan identitas dan akses, autentikasi, enkripsi apabila relevan,
      logging,
      pengelolaan kerentanan, backup dan pemulihan, pengamanan jaringan, pembatasan akses fisik, pengelolaan media
      dan
      dokumen, pengujian keamanan, audit, pelatihan, serta penghapusan/pemusnahan yang aman.
    </p>
    <p>
      PTPN IV menerapkan <i>privacy by design</i> dan <i>privacy by default</i> serta melakukan ROPA, penilaian
      risiko
      privasi, dan DPIA terhadap pemrosesan yang berpotensi menimbulkan risiko tinggi.
    </p>

    <h3>15. Hak Subjek Data Pribadi dan Batas Waktu Pemenuhan</h3>
    <p>
      Sesuai ketentuan yang berlaku, Subjek Data Pribadi memiliki hak untuk memperoleh informasi; mengakses dan
      memperoleh salinan; melengkapi, memperbarui, dan memperbaiki; menarik persetujuan; menunda atau membatasi
      pemrosesan; mengakhiri pemrosesan dan meminta penghapusan/pemusnahan; mengajukan keberatan atas keputusan
      otomatis; menggunakan portabilitas data apabila memenuhi ketentuan; mengajukan pengaduan; serta menggugat
      dan
      menerima ganti rugi atas pelanggaran pemrosesan.
    </p>
    <div class="privacy__table-wrap">
      <table>
        <thead>
          <tr>
            <th>Hak / Permintaan</th>
            <th>Batas Waktu / Ketentuan Umum</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Pembaruan/perbaikan</th>
            <td>Dilaksanakan paling lambat 3 x 24 jam sejak PTPN IV menerima permintaan.</td>
          </tr>
          <tr>
            <th scope="row">Akses Data Pribadi</th>
            <td>Diberikan paling lambat 3 x 24 jam sejak PTPN IV menerima permintaan akses, dengan verifikasi yang
              proporsional.</td>
          </tr>
          <tr>
            <th scope="row">Salinan Data Pribadi</th>
            <td>Disampaikan pada kesempatan pertama. Jika belum dapat disediakan, PTPN IV mengonfirmasi dan
              menyampaikan jangka waktu penyediaan paling lambat 3 x 24 jam sejak permohonan diterima dan
              terverifikasi.</td>
          </tr>
          <tr>
            <th scope="row">Penarikan persetujuan</th>
            <td>Pemrosesan yang semata-mata didasarkan pada persetujuan dihentikan paling lambat 3 x 24 jam sejak
              permintaan penarikan diterima, dengan memperhatikan pemrosesan yang telah dilakukan sebelumnya dan
              dasar hukum lain yang mungkin berlaku.</td>
          </tr>
          <tr>
            <th scope="row">Penundaan/pembatasan</th>
            <td>Dilaksanakan paling lambat 3 x 24 jam sejak permintaan diterima, sepanjang tidak terdapat
              pengecualian yang sah. Pemberitahuan pelaksanaan diberikan paling lambat 3 x 24 jam setelah tindakan
              dilakukan.</td>
          </tr>
          <tr>
            <th scope="row">Penolakan pembatasan</th>
            <td>Jika penolakan diperkenankan, alasan dan konsekuensinya disampaikan paling lambat 3 x 24 jam sejak
              permintaan diterima dan terverifikasi.</td>
          </tr>
          <tr>
            <th scope="row">Penghapusan/pemusnahan</th>
            <td>Dilaksanakan sesuai kondisi yang diwajibkan peraturan perundang-undangan. Apabila pemberitahuan
              diwajibkan, pemberitahuan diberikan paling lambat 3 x 24 jam sebelum dan/atau setelah tindakan
              sesuai
              mekanisme yang berlaku.</td>
          </tr>
          <tr>
            <th scope="row">Hak lainnya</th>
            <td>Dipenuhi sesuai persyaratan dan batas waktu yang ditetapkan peraturan perundang-undangan yang
              berlaku.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      Permohonan hak diajukan melalui kanal resmi PTPN IV. PTPN IV dapat melakukan verifikasi identitas dan
      kewenangan
      pemohon secara proporsional serta mencatat penerimaan, verifikasi, keputusan, pelaksanaan, pemberitahuan,
      dan
      dasar penolakan apabila ada. Permohonan hanya dapat ditolak berdasarkan alasan yang diperkenankan oleh
      peraturan
      perundang-undangan.
    </p>

    <h3>16. Kegagalan Pelindungan Data Pribadi</h3>
    <p>
      Dalam hal terjadi Kegagalan Pelindungan Data Pribadi, PTPN IV melakukan penilaian, mitigasi, investigasi,
      pemulihan, dokumentasi, serta tindakan perbaikan. PTPN IV menyampaikan pemberitahuan tertulis paling lambat
      3 x 24 (tiga kali dua puluh empat) jam kepada Subjek Data Pribadi yang terdampak dan Lembaga yang berwenang,
      terhitung sejak Kegagalan Pelindungan Data Pribadi diketahui secara pasti, patut, dan wajar, sesuai
      ketentuan yang
      berlaku.
    </p>
    <p>
      Pemberitahuan sekurang-kurangnya memuat Data Pribadi yang terungkap, kapan dan bagaimana Data Pribadi
      terungkap,
      upaya penanganan dan pemulihan, serta informasi PPDP atau narahubung yang ditunjuk. Dalam keadaan tertentu,
      PTPN IV
      juga melakukan pemberitahuan kepada masyarakat melalui media yang sesuai dan mudah diakses.
    </p>

    <h3>17. Pengalihan Data Pribadi dalam Aksi Korporasi</h3>
    <p>
      Dalam hal terjadi penggabungan, pemisahan, pengambilalihan, peleburan, pembubaran, atau tindakan korporasi
      lain
      yang mengakibatkan pengalihan Data Pribadi kepada Pengendali Data Pribadi baru, PTPN IV memastikan
      pengalihan
      dilakukan secara sah serta menjaga hak Subjek Data, keamanan, kerahasiaan, retensi, dan kewajiban
      pelindungan
      lainnya. PTPN IV memberikan pemberitahuan mengenai pengalihan sebelum dan/atau sesudah tindakan korporasi
      sesuai
      ketentuan yang berlaku.
    </p>

    <h3>18. Perubahan Pemberitahuan Privasi</h3>
    <p>
      PTPN IV dapat memperbarui Pemberitahuan Privasi ini apabila terdapat perubahan regulasi, proses bisnis,
      organisasi, teknologi, risiko, atau kegiatan pemrosesan. Untuk perubahan material yang memengaruhi tujuan,
      dasar
      pemrosesan, kategori Data Pribadi, penerima, retensi, transfer, atau hak Subjek Data, PTPN IV akan
      memberikan
      informasi mengenai perubahan tersebut sebelum atau pada saat perubahan berlaku sebagaimana dipersyaratkan.
    </p>

    <h3>19. Kontak, Pelaksanaan Hak, dan Pengaduan</h3>
    <p>
      Pertanyaan, permohonan pelaksanaan hak, atau pengaduan sehubungan dengan pemrosesan Data Pribadi oleh atau
      atas
      nama PTPN IV dapat disampaikan melalui kanal resmi berikut:
    </p>
    <div class="privacy__table-wrap">
      <table>
        <tbody>
          <tr>
            <th scope="row">Website</th>
            <td><a href="https://dtis-service.ptpn4.co.id" target="_blank"
                rel="noopener noreferrer">https://dtis-service.ptpn4.co.id</a></td>
          </tr>
          <tr>
            <th scope="row">E-mail</th>
            <td><a href="mailto:servicedesk@ptpn4.co.id">servicedesk@ptpn4.co.id</a><br><a
                href="mailto:privacy@ptpn4.co.id">privacy@ptpn4.co.id</a></td>
          </tr>
          <tr>
            <th scope="row">Telepon</th>
            <td>(021) 31119000 ext. 7002</td>
          </tr>
          <tr>
            <th scope="row">Alamat</th>
            <td>Gedung Agro Plaza Lantai 8, Jalan H.R. Rasuna Said Kav. X2 No. 1, Setiabudi, Jakarta Selatan</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      Permintaan, pertanyaan, dan pengaduan privasi yang diterima melalui Service Desk atau kanal resmi lainnya
      akan
      dicatat dan diteruskan kepada fungsi/unit terkait dan/atau Pejabat atau Petugas yang Melaksanakan Fungsi
      Pelindungan Data Pribadi (PPDP), apabila telah ditetapkan, untuk ditindaklanjuti sesuai kewenangan dan batas
      waktu
      yang berlaku. Apabila PTPN IV diwajibkan atau telah menetapkan PPDP, informasi kontak PPDP dan/atau kanal
      privasi
      khusus akan disediakan melalui kanal resmi Perusahaan. PPDP menjalankan fungsinya sesuai tugas, kewenangan,
      objektivitas, independensi, dan mekanisme komunikasi yang ditetapkan Perusahaan.
    </p>
    <p>
      <b>Pemberitahuan Privasi Spesifik:</b> Pemberitahuan Privasi Umum ini tidak menggantikan Pemberitahuan
      Privasi
      yang lebih spesifik apabila suatu kegiatan pemrosesan memiliki tujuan, kategori Data Pribadi, dasar
      pemrosesan,
      penerima, masa retensi, transfer, atau konsekuensi yang berbeda dan memerlukan informasi yang lebih rinci
      kepada
      Subjek Data Pribadi. Dalam hal tersedia Pemberitahuan Privasi yang lebih spesifik, dokumen tersebut berlaku
      sebagai
      informasi tambahan untuk konteks pemrosesan yang bersangkutan.
    </p>

    <h3>20. Acuan</h3>
    <ol type="a">
      <li>Undang-Undang Nomor 27 Tahun 2022 tentang Pelindungan Data Pribadi;</li>
      <li>Peraturan Pemerintah Nomor 33 Tahun 2026 tentang Peraturan Pelaksanaan Undang-Undang Nomor 27 Tahun 2022
        tentang Pelindungan Data Pribadi;</li>
      <li>ISO/IEC 27701:2025 <i>Information security, cybersecurity and privacy protection — Privacy information
          management systems — Requirements and guidance</i>;</li>
      <li>Kebijakan Privasi PT Perkebunan Nusantara IV.</li>
    </ol>

    <p class="privacy__ref">
      Dokumen DTIS/KBJ/3/IX/2026 · Revisi 00 · Terbit 22 September 2026
    </p>
  </div>
</template>
<script>
export default {
  name: "PrivacyNoticeContent",
};
</script>
<style>
.privacy {
  font-size: 0.9rem;
  line-height: 1.65;
  color: rgba(0, 0, 0, 0.85) !important;
}

.privacy h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 1.1rem 0 0.5rem;
}

.privacy h3:first-child {
  margin-top: 0.5rem;
}

.privacy ol {
  margin-bottom: 0.75rem;
}

.privacy ol[type="a"] {
  list-style-type: lower-alpha;
}

.privacy li {
  margin-bottom: 0.35rem;
}

.privacy__table-wrap {
  overflow-x: auto;
  margin-bottom: 0.75rem;
}

.privacy table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.privacy th,
.privacy td {
  border: 1px solid #ddd;
  padding: 0.4rem 0.6rem;
  text-align: left;
  vertical-align: top;
}

.privacy thead th {
  background: #f5f5f5;
  font-weight: 600;
}

.privacy tbody th {
  background: #fafafa;
  font-weight: 600;
}

.privacy__ref {
  font-size: 0.78rem;
  color: #777;
  margin-top: 1rem;
}
</style>
